import { render, staticRenderFns } from "./PageForDevice.vue?vue&type=template&id=653fa99f&scoped=true&"
import script from "./PageForDevice.vue?vue&type=script&lang=js&"
export * from "./PageForDevice.vue?vue&type=script&lang=js&"
import style0 from "./PageForDevice.vue?vue&type=style&index=0&id=653fa99f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fa99f",
  null
  
)

export default component.exports